Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.BarMenuViewFactory extends Backbone.Model
  initialize: ({exportable = true, resizable = true} = {}) =>
    @exportable = exportable
    @resizable = resizable

  create: (widget, data) ->
    new Common.Dashboard.Charts.BarMenuView({
      exportable: @exportable,
      resizable: @resizable,
      isMaximized: widget.get('is_maximized'),
      customOptionViews: _.compact(@_customOptionViews(widget, data))
    })

  _customOptionViews: (widget, data) ->
    views = []
    views.push(@_missingValuesOptionView(widget)) if widget.canShowMissingOption(data)
    views.push(@_showQuantityOptionView(widget)) if widget.canSelectQuantityToShow()
    views.push(@_useWorkCalendarOptionView(widget)) if widget.canToggleWorkCalendar()
    views

  _missingValuesOptionView: (widget) ->
    new CustomerVisualMode.Charts.MissingValuesOptionView({showAll: widget.get('show_missing')})

  _showQuantityOptionView: (widget) ->
    new CustomerVisualMode.Charts.ShowQuantityOptionView({isShowingTopTen: widget.get('show_top_ten')})

  _useWorkCalendarOptionView: (widget) ->
    new CustomerVisualMode.Charts.UseWorkCalendarOptionView({isUsingWorkCalendar: widget.get('use_work_calendar')})
